import React from 'react'
import PropTypes from 'prop-types'
import Title from 'shared/components/Title'

import { Container, Grid, Segment } from 'semantic-ui-react'
import SignUpForm from '../../containers/SignUpFormV2'
import constants from 'config/constants'

import styled from 'styled-components'

class SignUp extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
  }

  render() {
    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          backgroundImage: "url('https://cdn.simplesat.io/images/signup-bg.jpg')",
          backgroundSize: 'cover',
        }}
      >
        <Container className="!h-full">
          <Grid centered verticalAlign="middle" textAlign="center" className="!h-full">
            <Grid.Column mobile={16} tablet={12} computer={12}>
              <SubContainer>
                <Title title="Sign up" />
                <Segment verticalAlign="middle" textAlign="center">
                  <div className="flex flex-row w-full align-middle pt-6 pb-6">
                    <div className="ui middle aligned simplesat-achievement flex-1">
                      <h1>
                        Join the ranks of 1,000+ <br />
                        service-minded businesses
                      </h1>
                      <div className="feedback-achievement">
                        <div className="simplesat-testimonial">
                          <img
                            className="w-20"
                            alt="star"
                            src={constants.awardsStar}
                          />
                          <p className="simplesat-testimonial-header-text">
                            “We are getting much more valuable <br />
                            feedback from our clients.”
                          </p>
                          <p className="simplesat-testimonial-footer-text">− Chris P.</p>
                        </div>

                        <div className="simplesat-testimonial">
                          <img
                            className="w-20"
                            alt="star"
                            src={constants.awardsStar}
                          />
                          <p className="simplesat-testimonial-header-text">
                            “Simplesat is the gold standard for service.”
                          </p>
                          <p className="simplesat-testimonial-footer-text">− Paul G.</p>
                        </div>

                        <div className="simplesat-testimonial">
                          <img
                            className="w-20"
                            alt="star"
                            src={constants.awardsStar}
                          />
                          <p className="simplesat-testimonial-header-text">
                            “Having Simplesat on my team helps me <br />
                            sleep at night.”
                          </p>
                          <p className="simplesat-testimonial-footer-text">− Kevin L.</p>
                        </div>

                        <div className="whitespace-nowrap">
                          <img
                            className="simplesat-g2-icon"
                            src={constants.g2Badge1}
                            alt="g2-icon-1"
                          />
                          <img
                            className="simplesat-g2-icon"
                            src={constants.g2Badge2}
                            alt="g2-icon-2"
                          />
                          <img
                            className="simplesat-g2-icon"
                            src={constants.g2Badge3}
                            alt="g2-icon-3"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ui middle aligned flex-1 simplesat-signup-section">
                      <SignUpForm history={this.props.history} />
                    </div>
                  </div>
                </Segment>
              </SubContainer>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    )
  }
}

const SubContainer = styled.div`
  .simplesat-achievement {
    border-right: 1px solid rgba(88, 102, 126, 0.12);
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }

  .simplesat-testimonial {
    margin-bottom: 12px;
  }

  .simplesat-testimonial-header-text {
    font-size: 16px;
    margin-bottom: 4px;
  }

  .simplesat-testimonial-footer-text {
    font-size: 14px;
    color: grey;
  }

  .simplesat-g2-icon {
    width: 90px;
    height: 95px;
    padding-left: 8px;
    padding-right: 8px;
  }

  .simplesat-signup-section {
    max-width: 50%;

    @media only screen and (max-width: 768px) {
      max-width: 100%;
    }
  }
`

export default SignUp



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/SignUp/index.js